import React from "react";
import { graphql } from "gatsby";
import { Resources } from "./Resources";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  KontentImage,
  KontentVideo,
  StringValue,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatVideo } from "../../../lib/videos";
import { formatImages } from "../../../lib/images";
import { LinkedImageProps } from "../LinkedImage";
import { formatLinks } from "../../../lib/links";

interface Props extends KontentComponentLayout, KontentComponentSettings {
  heading: StringValue;
  resources: {
    value: (
      | { elements: LinkedImageProps; system: { type: string } }
      | KontentVideo
    )[];
  };
}

const ResourcesContainer: React.FC<Props> = ({
  heading,
  resources,
  ...props
}) => {
  const settings = getComponentSettings({ ...props });

  const resourceArr = resources.value.map((resource) => {
    return resource.system?.type === "video"
      ? formatVideo(resource?.elements as unknown as KontentVideo["elements"])
      : {
          link: formatLinks(
            resource?.elements?.link_configuration__link?.modular_content
          )[0],
          image: formatImages(
            resource?.elements.image?.modular_content[0].elements
          ).largeImage,
        };
  });

  return (
    <Resources
      {...settings}
      heading={heading?.value}
      resources={resourceArr}
    ></Resources>
  );
};

export default ResourcesContainer;

export const fragmentResourcesContainer = graphql`
  fragment Resources on kontent_item_resources {
    elements {
      component_layout__component_width {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      heading {
        value
      }
      resources {
        value {
          ...kontentVideo
          ...LinkedImage
        }
      }
    }
  }
`;
